import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortListObjectByKeyPipe'
})
export class SortListObjectByKeyPipe implements PipeTransform {
  transform(collection: any, key: string): any {
  	if (key) {
      collection.sort((a, b) => {
        return (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
      });
    }

    return collection;
  }
}
